import { Container, Divider } from '@mui/material';
import Action from './components/Action';
import Headline from './components/Headline';
import InfoBits from './components/InfoBits';
import JimBio from './components/JimBio';
import LogoMeaning from './components/LogoMeaning';
import Story from './components/Story';

/**
 * The about view describes who and what S3G Security is
 */
const AboutView = () => {
  return (
    <Container>
      <Headline />
      <Divider />
      <Story />
      <Divider />
      <JimBio />
      <Divider />
      <LogoMeaning />
      <Divider />
      <InfoBits />
      <Action />
    </Container>
  );
};

export default AboutView;
